import { render, staticRenderFns } from "./DashboardBody.vue?vue&type=template&id=a6e2ea58&scoped=true"
import script from "./DashboardBody.vue?vue&type=script&lang=js"
export * from "./DashboardBody.vue?vue&type=script&lang=js"
import style0 from "./DashboardBody.vue?vue&type=style&index=0&id=a6e2ea58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e2ea58",
  null
  
)

export default component.exports